/**
 * @file index.tsx
 *
 * @fileoverview Shows the organization banner.
 */
import React from 'react';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Image } from '~/jobiqo/components/Image';
import { FlatBanner } from '~/vcl/organisms/04-landingpage/01-flat-banner';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import styles from './banner.module.scss';

export interface OrganizationBannerWidgetProps {
  organization: OrganizationProfile;
}

export const OrganizationBannerWidget = ({
  organization,
}: OrganizationBannerWidgetProps) => {
  return organization.cover?.url ? (
    <div className={styles.bannerWrapper}>
      <Image
        width={null}
        height={null}
        src={organization.cover?.url}
        alt={
          organization.cover?.alt
            ? organization.cover?.alt
            : `${organization.name} cover`
        }
        {...(organization.cover?.title && {
          title: organization?.cover?.title,
        })}
        priority={true}
      />
    </div>
  ) : (
    <FlatBanner flatbannerStyle="default" backgroundColor="default">
      <Spacing padding={10} />
    </FlatBanner>
  );
};
